import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'OrganizationIdentifierType';
const ENDPOINT = `/organization-identifier-types/`;

@Injectable({
    providedIn: 'root'
})
export class OrganizationIdentifierTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
